<template>
    <div class="mx-auto px-3 lg:mx-[16.5rem] lg:px-0 lg:mt-2 text-center">
        <template v-if="!isRequestSuccess">
            <ShcUiHeading
                :tag="HEADING_TAG.h1"
                class="mb-8 lg:mb-12 text-xl lg:!text-[1.75rem] font-semibold text-left"
                data-cy="forgot-password_heading"
            >
                {{ $t('Bbk.form.reset.heading') }}
            </ShcUiHeading>
            <div class="w-full mx-auto lg:w-[506px]">
                <ShcUiParagraph
                    :theme="PARAGRAPH_THEME.tertiary"
                    class="mb-7 text-xs font-normal text-left lg:!text-base"
                >
                    {{ $t('Bbk.form.reset.content') }}
                </ShcUiParagraph>
                <FormKit v-slot="{ state: { valid } }" type="form" :actions="false" @submit="onSubmitHandler">
                    <BaseInput
                        type="email"
                        name="email"
                        validation="required|email"
                        validation-visibility="live"
                        :label="$t('Bbk.form.reset.emailAddress')"
                    />
                    <ShcUiButton
                        type="submit"
                        data-cy="reset_password_btn"
                        full
                        class="mt-4 uppercase lg:mt-7 disabled:bg-bbk-grey"
                        :disabled="!valid || isPasswordResetInProgress"
                    >
                        <LazyShcUiLoader
                            v-if="isPasswordResetInProgress"
                            size="tiny"
                            class="w-[1.125rem] h-[1.125rem] lg:w-5 lg:h-5"
                        />
                        <span v-else>{{ $t('Bbk.form.reset.send') }}</span>
                    </ShcUiButton>
                </FormKit>
            </div>
        </template>
        <LazyShcUiFormPasswordConfirmation v-else :text="$t('Bbk.form.confirmation.resetContent')" />
    </div>
</template>

<script lang="ts" setup>
    import { HEADING_TAG } from '@shc/nuxt-shc-ui-layer/components/Heading/heading'
    import { PARAGRAPH_THEME } from '@shc/nuxt-shc-ui-layer/components/Paragraph/paragraph'
    import type { PasswordReset } from '@shc/nuxt-shc-ui-layer/components/Form/Password/Reset/formPasswordReset'
    import type { Props } from './props'

    defineProps<Props>()

    const emit = defineEmits<{
        passwordResetRequest: [formData: PasswordReset]
    }>()

    const { $bus } = useNuxtApp()
    const isPasswordResetInProgress = ref(false)

    function onSubmitHandler(formData: PasswordReset) {
        isPasswordResetInProgress.value = true
        emit('passwordResetRequest', formData)
    }

    $bus.$on('customerRequestResetPasswordDone', () => {
        isPasswordResetInProgress.value = false
    })
</script>
